import { dateFromNow, formatFromNow } from 'utils/dateUtils'
import { FormattedDateSpan } from './Styled'

export type FormattedDateProps = {
  date: string
}

const FormattedDate = ({ date }: FormattedDateProps) => {
  let formattedDate = ''

  if (date) {
    const fromNow = dateFromNow(new Date(date))
    formattedDate = formatFromNow({
      days: Math.abs(fromNow.days),
      hours: Math.abs(fromNow.hours),
      minutes: Math.abs(fromNow.minutes),
      seconds: Math.abs(fromNow.seconds),
    })
  }
  return <FormattedDateSpan>{formattedDate}</FormattedDateSpan>
}

export default FormattedDate
